import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import { IoAddOutline, IoDocumentTextOutline, IoSearch } from 'react-icons/io5';
import { query, collection, onSnapshot, orderBy } from "firebase/firestore";
import OutletHead from '../../../components/common/outlet-head';
import { db } from '../../../firebase';
import { useAuth } from '../../../context/AuthContext';
import { IoIosList } from "react-icons/io";
import Datatable from '../../../components/leads/datatable';
import AddNewLead from '../../../components/modals/lead/add-lead';
import SelectDropdown from '../../../components/common/utils/select-dropdown';

function Leads() {

  const { user } = useAuth();
  const { bid } = user.claims;
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState(null);
  const [showLeadModal, setShowLeadModal] = useState(false);

  const getExpenses = () => {
    const q = query(collection(db, "Businesses", bid, "Leads"), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach((doc) => {
        tempData.push({ id: doc.id, ...doc.data() });
      });

      setData(tempData);
      setIsLoading(false);
    }, (error) => {
      console.log(error.message);
      setIsLoading(false);
    });

    return () => unsubscribe;
  }

  useEffect(() => {
    getExpenses();
  }, []);

  const filteredData = data && data.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.source.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.phoneNumber.toLowerCase().includes(searchTerm) ||
    item.status.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <section className='section'>
      <OutletHead
        left={
          <h5 className='mb-0 fw-600'>Manage Leads</h5>
        }
        right={
          <div className='d-flex align-items-center'>
            <Button
              variant="outline-primary"
              type="submit"
              className='py-2 px-4'
            >
              <IoDocumentTextOutline size={18} />
              <span className='ps-2'>Report</span>
            </Button>
          </div>
        }
      />
      <div className='p-3 border-top'>
        <div className='row'>
          <div className='col-lg-12'>
            {
              isLoading ?
                <div className='data-loading-container'>
                  <div className='loader'>
                    <div className='spinner' />
                  </div>
                </div>
                :
                <div className='mb-5'>
                  <div className='pb-3'>
                    <Form>
                      <div className='row'>
                        <div className='col-xl-10 col-lg-9 col-md-9 col-9'>
                          <div className='row'>
                            <div className='col-4'>
                              <div className='position-relative'>
                                <div className='position-absolute left-0 top-0 bottom-0 ps-3 d-flex align-items-center justify-content-center'>
                                  <IoSearch size={20} color={`var(--bs-placeholder)`} />
                                </div>
                                <Form.Control
                                  type="text"
                                  placeholder="Search by name or phone number"
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  className='ps-5'
                                />
                              </div>
                            </div>
                            <div className='col-3'>
                              <SelectDropdown
                                searchable={false}
                                maxHeight={200}
                                options={[
                                  { name: "All", value: "" },
                                  { name: "New", value: "New" },
                                  { name: "Contacted", value: "Contacted" },
                                  { name: "Site Visit Done", value: "Site Visit Done" },
                                  { name: "Converted", value: "Converted" },
                                  { name: "Lost", value: "Lost" }
                                ]}
                                labelField="name"
                                valueField="value"
                                placeholder="Filter by Status"
                                selectedValue={searchTerm === "" ? "All" : searchTerm}
                                onSelect={(value) => value === "All" ? setSearchTerm("") : setSearchTerm(value)}
                                menuClass="shadow"
                              />
                            </div>
                            <div className='col-3'>
                              <SelectDropdown
                                searchable={false}
                                maxHeight={200}
                                options={[
                                  { name: "Today", value: "Today" },
                                  { name: "Yesterday", value: "Yesterday" },
                                  { name: "This Week", value: "This Week" },
                                  { name: "Last Week", value: "Last Week" },
                                  { name: "Last 7 Days", value: "Last 7 Days" },
                                  { name: "This Month", value: "This Month" },
                                  { name: "Previous Month", value: "Previous Month" },
                                  { name: "Current Fiscal Year", value: "Current Fiscal Year" },
                                  { name: "Previous Fiscal Year", value: "Previous Fiscal Year" },
                                  { name: "Last 365 Days", value: "Last 365 Days" },
                                  { name: "Custom Date Range", value: "Custom Date Range" }
                                ]}
                                labelField="name"
                                valueField="value"
                                placeholder="Please select"
                                searchPlaceholder="Search..."
                                selectedValue={data && data.city}
                                onSelect={(value) => setData({ ...data, city: value })}
                                menuClass="shadow"
                              />
                            </div>
                          </div>
                        </div>
                        <div className='col-xl-2 col-lg-3 col-md-3 col-6'>
                          <div className='d-flex justify-content-end'>
                            <Button
                              variant="primary"
                              type="button"
                              className='py-2 px-3 ms-3'
                              onClick={() => setShowLeadModal(true)}
                            >
                              <IoAddOutline size={20} />
                              <span className='ps-2'>New Lead</span>
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>

                  <Datatable
                    columns={["Lead", "Type", "Source", "Phone Number", "Email", "Date", "Status"]}
                    data={filteredData}
                  />
                </div>
            }
          </div>
        </div>
      </div>

      <AddNewLead
        showModal={showLeadModal}
        setShowModal={setShowLeadModal}
      />

    </section>
  );
}

export default Leads;